export const imageNames = {
  BOLT_ICON: 'boltIcon',
  INFO_ICON: 'infoIcon',
  DISCOUNT_ICON: 'discountIcon',
  LOGOUT_ICON: 'logoutIcon',
  ONLINE_NAV_ICON: 'onlineNavIcon',
  SUPER_AGI_ICON: 'superAgiIcon',
  DISCORD_ICON: 'discordIcon',
  SUPER_AGI_TEXT: 'superAgiText',
  MANAGE_BILLING: 'manage_billing',
  SELECTED_MANAGE_BILLING: 'selected_manage_billing',
  SOFTWARE_CREDITS: 'software_credits',
  SELECTED_SOFTWARE_CREDITS: 'selected_software_credits',
  PAYMENT_METHODS: 'payment_methods',
  INVOICES: 'invoices',
  SELECTED_INVOICES: 'selected_invoices',
  WORKER_ACTIVITY: 'worker_activity',
  SELECTED_WORKER_ACTIVITY: 'selected_worker_activity',
  OPEN_IN_NEW: 'open_in_new',
  SORTING_ARROW: 'sortingArrow',
  SORTING_ARROW_SELECTED: 'sortingArrowSelected',
  LEFT_ARROW_ICON: 'leftArrowIcon',
  RIGHT_ARROW_ICON: 'rightArrowIcon',
  VERIFIED: 'verified',
  MORE_ICON_VERTICAL_DISABLED: 'moreIconVerticalDisabled',
  MORE_ICON_VERTICAL: 'moreIconVertical',
  STATUS_BULLET: 'statusBullet',
  CLOSE_ICON: 'closeIcon',
  WHITE_DOT: 'whiteDot',
  ARROW_DOWN_TOOLTIP: 'arrowDownTooltip',
  PROFILE_ICON_PLACEHOLDER: 'profileIconPlaceholder',
  PRODUCTS_ADMIN: 'products_admin',
  SELECTED_PRODUCTS_ADMIN: 'selected_products_admin',
  EMPTY_SCREEN: 'emptyScreen',
  DOWNLOAD_ICON: 'downloadIcon',
  REMOVE_ICON: 'removeIcon',
  CHECK: 'check',
  WORKSPACE_FILLED: 'workspaceFilled',
  WORKSPACE_EMPTY: 'workspaceEmpty',
  ADD_ICON: 'addIcon',
  PREVIEW_ICON: 'previewIcon',
  COIN_ICON: 'coinIcon',
  MINUS_ICON: 'minusIcon',
  GREY_TICK_CIRCLE: 'greyTickCircle',
  GREEN_TICK_CIRCLE: 'greenTickCircle',
  DOWN_ARROW_BLACK_ICON: 'downArrowBlackIcon',
  CANCEL_GREY_CIRCLE_ICON: 'cancelGreyCircleIcon',
  EMAIL_PINK_ICON: 'emailPinkIcon',
  PHONE_PINK_ICON: 'phonePinkIcon',
  MARKET_RESEARCH_PINK_ICON: 'marketResearchPinkIcon',
  SIGNAL_PINK_ICON: 'signalPinkIcon',
  POKER_PINK_ICON: 'pokerPinkIcon',
  DRAG_ICON_GREY: 'dragIconGrey',
  QUESTION_MARK: 'questionMark',
  CLOCK_ICON: 'clockIcon',
  LOCK_ICON: 'lockIcon',
  WARNING_ICON: 'warningIcon',
  VISA_ICON: 'visaIcon',
  MASTERCARD_ICON: 'mastercardIcon',
  AMEX_ICON: 'amexIcon',
  DISCOVER_ICON: 'discoverIcon',
  UNKNOWN_ICON: 'unknownIcon',
};
